module.exports = __webpack_public_path__ + "static/img/footer03.0a6a2e8c.png";